var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 9.5,
    fill: "#18C347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4C9.152 4 4 9.152 4 15.5C4 21.848 9.152 27 15.5 27C21.848 27 27 21.848 27 15.5C27 9.152 21.848 4 15.5 4ZM15.5 8.6C17.7195 8.6 19.525 10.4055 19.525 12.625C19.525 14.8445 17.7195 16.65 15.5 16.65C13.2805 16.65 11.475 14.8445 11.475 12.625C11.475 10.4055 13.2805 8.6 15.5 8.6ZM15.5 24.7C13.1655 24.7 10.4055 23.757 8.439 21.388C10.4533 19.8076 12.9397 18.9486 15.5 18.9486C18.0603 18.9486 20.5467 19.8076 22.561 21.388C20.5945 23.757 17.8345 24.7 15.5 24.7Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNav);
export default __webpack_public_path__ + "static/media/profile_nav.a67e2f95d2bf85e0138096f832fd2b42.svg";
export { ForwardRef as ReactComponent };